import SectionPage from "./SectionPage";
import DeliveryCalculator from "./DeliveryCalculator";
import QuoteForm from "./QuoteForm";

/**
 * Dedicated quote page (/quote) housing the Delivery Calculator and the
 * Request-a-Quote form. Moved off the home screen so visitors who arrive
 * via "Request Quote" links land directly on a focused conversion page.
 */
export const QuotePage = () => (
  <SectionPage
    eyebrow="Plan Your Event"
    title="Request a Quote"
    subtitle="Check delivery availability for your ZIP code and share a few details — a member of the Fresh Fast Foods team will follow up with a custom quote."
    hero="charcoal"
  >
    <DeliveryCalculator />
    <QuoteForm />
  </SectionPage>
);

export default QuotePage;
